query CampaignsOnlyByClient($clientId: ID!, $orderBy: CampaignOrderBy) {
    campaigns(clientId: $clientId, orderBy: $orderBy) {
        _id
        id
        name
    }
}
